export default "__VITE_ASSET__DX_nEco5__"